import { render, staticRenderFns } from "./ViewSchool.vue?vue&type=template&id=a662d12e&scoped=true"
import script from "./ViewSchool.vue?vue&type=script&lang=js"
export * from "./ViewSchool.vue?vue&type=script&lang=js"
import style0 from "./ViewSchool.vue?vue&type=style&index=0&id=a662d12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a662d12e",
  null
  
)

export default component.exports